import {
  NavigationEnd,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import {
  DsBoxModule,
  DsButtonModule,
  DsHeaderModule,
  DsHeaderTagConfiguration,
  DsHeaderUserInfo,
  DsImprintModule,
  DsNavigationBarModule,
  DsNavigationItem,
  DsTableModule,
} from '@bmw-ds/components';
import {
  Component,
  effect,
  inject,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserStateService } from './services/user-state.service'; // ✅ import this

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    DsNavigationBarModule,
    DsHeaderModule,
    DsBoxModule,
    DsImprintModule,
    DsButtonModule,
    RouterOutlet,
    RouterModule,
    DsTableModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  isLandingPage: boolean = false;
  isUnitUpdate: boolean = false;
  private userState = inject(UserStateService);
  @ViewChild('navBar') navBar: any;
  environmentTagConfig: WritableSignal<Partial<DsHeaderTagConfiguration>> =
    signal({ label: 'DEV' });
  userInfo: WritableSignal<Partial<DsHeaderUserInfo>> = signal({
    username: this.userState.employeeName(),
    department: this.userState.companyId(),
    profileImg: 'https://www.gravatar.com/avatar/?d=identicon',
  });

  //Navigation configuration
  navigationItems: WritableSignal<DsNavigationItem[]> = signal([
    {
      label: 'Stock',
      icon: 'car',
      children: [
        {
          label: 'Stock Unit Search',
          routerLink: '/stock-unit-search',
        },
        {
          label: 'NaTIS Documents',
          routerLink: '/natis-documents',
        },
        {
          label: 'Dealer Summary',
          routerLink: '/dealer-summary',
        },
      ],
    },
  ]);

  title = 'Cross Border System';

  constructor(private readonly router: Router) {
    effect(() => {
      const name = this.userState.employeeName();
      this.userInfo.update((prev) => ({ ...prev, username: name }));
    });

    effect(() => {
      const department = this.userState.companyId();
      this.userInfo.update((prev) => ({ ...prev, department }));
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isLandingPage = this.router.url === '/' || this.router.url === '/landing';
        this.isUnitUpdate = this.router.url.includes('/unit-update');
        console.log('unit', this.isUnitUpdate);
      });
  }
}
